import { switcher } from './utils';
import objectRecord from './object_record';
import { ACTIONS } from '../const';

const printJob = objectRecord({
    id: null,
    percent: 0,
    stage: 'PREPARING',
    content: null,
    pageList: [],
    urls: [],
});

const set = (index, value, list) => {
    const tmp = list.slice();
    tmp[index] = value;
    return tmp;
};

export default switcher([], {
    [ACTIONS.NEW_PRINT_JOB](state, { content, pageList }) {
        const id = state.length;

        const job = printJob({
            id,
            content,
            pageList,
        });

        return set(id, job, state);
    },
    [ACTIONS.PRINT_PROGRESS](state, { id, percent, stage }) {
        const printJob = {
            ...state[id],
            percent: Math.round(percent),
            stage,
        };

        return set(id, printJob, state);
    },
    [ACTIONS.PRINT_DONE](state, { id, urls }) {
        const printJob = {
            ...state[id],
            percent: 100,
            stage: 'DONE',
            urls: urls,
        };

        return set(id, printJob, state);
    },
});



// WEBPACK FOOTER //
// ./src/reducers/print.js